import React, {useEffect, useState} from 'react';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import { DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const StyledButton = withStyles({
  root: {
    borderRadius: 0,
  },
  startIcon: {
    marginLeft: 0,
  },
  iconSizeLarge: {
    '& > *:first-child': {
      fontSize: 28,
    },
  },
})(Button);

export const PDFDownload =  () => {
  const configuration = useSelector(state => state.configurator.savedConfiguration);
  const [pdfUrl, setPdfUrl] = useState(null);
  useEffect(() => {
    const createLink = async () => {
      const pdfLink = await Services.interaction.createPdfUrl('user', configuration);
         setPdfUrl(pdfLink);
    }
   createLink();
  }, []);
  
  return (
    <AnalyticsWrapper targetId={'picture_as_pdf'}>
      <StyledButton
        size="large"
        startIcon={<PictureAsPdfIcon />}
        href={pdfUrl}
        target="_blank"
        color="primary"
        variant="contained"
      >
        {t('receiveOfferForm.downloadPdf')}
      </StyledButton>
    </AnalyticsWrapper>
  );
};

export const FeedbackSuccessDialog = ({ open, onClose }) => {
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      aria-labelledby="feedback-dialog-title"
      aria-describedby="feedback-dialog-description"
      onCancel={onClose}
      dialogTitle={t('errorDialogTitle')}
    >
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          dangerouslySetInnerHTML={{ __html: t('receiveOfferForm.sentOk') }}
        />
      </DialogContent>
      <DialogActions>
        <PDFDownload />
      </DialogActions>
    </CustomDialog>
  );
};

FeedbackSuccessDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FeedbackSuccessDialog;
